module.exports = __webpack_public_path__ + "static/media/SportTogether.fd33ea37.svg";